<template>
  <component
    :is="as"
    class="add-link"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <icon class="icon" name="add" />

    <span>
      <slot />
    </span>
  </component>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    as: {
      type: String,
      default: 'a',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.add-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
  font-size: inherit;

  .icon {
    font-size: inherit;
    margin-right: 5px;
  }

  &:hover {
    text-decoration: none;

    span {
      text-decoration: underline;
    }
  }
}
</style>
